/* Preserve campaign parameters on the native Mojis Club link. */
(() => {
  // Decorate the native Club link without intercepting navigation or product routing.
  const decorate = () => document.querySelectorAll('[data-mojis-club-link]').forEach(link => {
    const destination = new URL(link.href, location.href);
    const clubPath = new URL(`${window.Shopify?.routes?.root || '/'}pages/mojis-club`, location.origin).pathname;
    if (destination.origin !== location.origin || destination.pathname !== clubPath) return;
    new URLSearchParams(location.search).forEach((value, key) => {
      if (/^utm_/i.test(key) || ['fbclid', 'gclid', 'ttclid', 'msclkid', 'gbraid', 'wbraid'].includes(key)) {
        destination.searchParams.set(key, value);
      }
    });
    link.href = destination.pathname + destination.search + destination.hash;
  });
  decorate();
  document.addEventListener('shopify:section:load', decorate);
})();
